export default "__VITE_ASSET__DrT2vD$s__"